module.exports = __webpack_public_path__ + "img/ic_round_plus.5d958453.svg";